import apiClient from '../apiClient';
import { POST_SET_PRIMARY_IMAGE_RESTAURANT_ITEM_URL } from '../apiUrl';

const postSetPrimaryImageRestaurantItemApi = (id, data) => {
  return apiClient.post(POST_SET_PRIMARY_IMAGE_RESTAURANT_ITEM_URL(id), data);
};

export default postSetPrimaryImageRestaurantItemApi;
